import React from 'react';
// import './Footer.css'; // Assuming you'll store your CSS here


function Footer() {
    return (
        //<!-- Footer -->
        <footer class="bg-secondary text-white text-center py-3 fixed-bottom">
            <div class="container">
                <p>&copy; 2024 Bakeonator. All Rights Reserved.</p>
            </div>
        </footer>
    )
}

export default Footer;